import { NutritionSerializer } from 'fitbeat.gym-core';
import { ShoppingListExclusion } from 'fitbeat.models';
import firebaseErrorHandler from '../utils/FirebaseErrors';
import Storage from '../utils/Storage';

import {
  SAVE_FOOD_PREFERENCES_REQUEST,
  SAVE_FOOD_PREFERENCES_SUCCESS,
  SAVE_FOOD_PREFERENCES_FAILED,
  SAVE_DIET_GOAL_REQUEST,
  SAVE_DIET_GOAL_SUCCESS,
  SAVE_DIET_GOAL_FAILED,
  GET_MEALS_FOR_TIME_OF_DAY_REQUEST,
  GET_MEALS_FOR_TIME_OF_DAY_SUCCESS,
  GET_MEALS_FOR_TIME_OF_DAY_FAILED,
  GET_MEAL_PLAN_REQUEST,
  GET_MEAL_PLAN_SUCCESS,
  GET_MEAL_PLAN_FAILED,
  GET_SHOPPING_LIST_REQUEST,
  GET_SHOPPING_LIST_SUCCESS,
  GET_SHOPPING_LIST_FAILED,
  SET_THUMBNAILS,
  SET_IMAGE,
  GET_THUMBNAILS_REQUEST,
  SET_USER_MEAL_PLAN_REQUEST,
  SET_SHOPPING_LIST_SETTINGS_REQUEST,
  SET_SHOPPING_LIST_SETTINGS_FAILED,
  SET_SHOPPING_LIST_SETTINGS_SUCCESS,
  SET_CHECKLIST_EXCLUSIONS_FAILED,
  SET_USER_MEAL_PLAN_SUCCESS,
  SET_USER_MEAL_PLAN_FAILED,
  SET_NUTRITION_PREFERENCE,
  CLEAR_MEALS_FOR_TIME_OF_DAY,
  SET_TAB_INDEX,
  SET_NUTRITION_RATING_REQUEST,
  SET_NUTRITION_RATING_FAILED,
  SET_NUTRITION_RATING_SUCCESS,
  GET_NUTRITION_RATING_DATA,
  TOGGLE_NUTRITION_REVIEW_BODY,
  GET_NUTRITION_RATING_DATA_FAILED,
  CHANGE_NUTRITION_DAY,
  MEAL_DETAILED_TAB_SELECT,
  OPEN_NUTRITION_STEP_VIDEO,
  UNCHECK_ALL_SHOPPING_LIST_ITEMS,
  TOGGLE_SHOPPING_LIST_ITEM_CHECK_STATUS,
  ORDER_MEALS_OPEN,
  NUTRITION_PREFERENCE_CHANGE,
  NUTRITION_TAB_SELECTED,
  MEAL_ROW_PRESSED,
  TOGGLE_MEAL_SELECTION_WIZARD_SCREEN,
  MAXIMUM_MEAL_PREP_TIME_CHANGED,
  SET_UNIT_PREFERENCE,
} from './actionTypes'
import { toggleFoodPreferencesModal, toggleMealModal } from '../ui';
import { analyicsForAction } from '../services/google-analytics/analyicsForAction';
import { Logger } from '../utils';

export const mealRowPressed = (mealOfDay, meal) => {
  return {
    type: MEAL_ROW_PRESSED,
    payload: {
      mealOfDayOpenInModal: mealOfDay,
      mealOpenInModal: meal,
    }
  };
}

export const clearMealsForTimeOfDay = () => {
  return {
    type: CLEAR_MEALS_FOR_TIME_OF_DAY,
  }
}

export const changeNutritionDay = (newDay) => {
  return {
    type: CHANGE_NUTRITION_DAY,
    payload: {
      newDay,
    },
    ...analyicsForAction(CHANGE_NUTRITION_DAY),
  }
}

export const mealDetailTabSelected = (selectedTab) => {
  return {
    type: MEAL_DETAILED_TAB_SELECT,
    ...(selectedTab ? analyicsForAction(MEAL_DETAILED_TAB_SELECT, { selectedTab: selectedTab.title }) : {})
  }
}

export const openNutritionStepsVideo = (videoName) => {
  return {
    type: OPEN_NUTRITION_STEP_VIDEO,
    ...analyicsForAction(OPEN_NUTRITION_STEP_VIDEO, { videoName })
  }
}

export const nutritionTabSelected = (tabTitle) => {
  return {
    type: NUTRITION_TAB_SELECTED,
    ...analyicsForAction(NUTRITION_TAB_SELECTED, { tabTitle })
  }
}

export const nutritionPreferenceChange = (selectedPreference) => {
  return {
    type: NUTRITION_PREFERENCE_CHANGE,
    ...analyicsForAction(NUTRITION_PREFERENCE_CHANGE, { selectedPreference })
  }
}

const setUserMealPlanRequest = (newMeal) => {
  return {
    type: SET_USER_MEAL_PLAN_REQUEST,
    payload: {
      newMeal
    },
  }
}
const setUserMealPlanSuccess = (mealPlan, shoppingList, mealOfDay) => {
  return {
    type: SET_USER_MEAL_PLAN_SUCCESS,
    payload: {
      mealplan: mealPlan,
      shoppingList: shoppingList,
    },
    ...analyicsForAction(SET_USER_MEAL_PLAN_SUCCESS, { mealOfDay })
  }
}

const setUserMealPlanFailed = (error) => {
  return {
    type: SET_USER_MEAL_PLAN_FAILED,
    payload: {
      error
    }
  }
}

export const setUserMealPlan = (nutritionService, mealId, mealOfDay, day, newMeal) => {
  return async (dispatch) => {
    dispatch(setUserMealPlanRequest(newMeal));
    try {
      const weekDay = day.format('dddd');
      const data = await nutritionService.setUserMealPlan(mealId, mealOfDay, weekDay);
      const serializedMealPlanData = NutritionSerializer.deserializeMealPlanWithMeals(data);
      const shoppingListData = await nutritionService.getShoppingList();
      dispatch(setUserMealPlanSuccess(serializedMealPlanData, shoppingListData, mealOfDay));
      dispatch(getImage(nutritionService, mealId));
    } catch (error) {
      dispatch(setUserMealPlanFailed(error));
    }
  }
}
export const toggleNutritionReviewBody = () => {
  return {
    type: TOGGLE_NUTRITION_REVIEW_BODY,
  }
}

const getNutritionRatingDataError = (error) => {
  return {
    type:  GET_NUTRITION_RATING_DATA_FAILED,
    payload: {
      error
    }
  }
}

const getNutritionRatingDataCall = (userProfile, latestRating) => {
  return {
    type: GET_NUTRITION_RATING_DATA,
    payload: {
      userProfile,
      latestRating,
    }
  }
}

export const getNutritionRatingData = (nutritionService, userProfile) => {
  return async (dispatch) => {
    try {
      const latestNutritionRating = await nutritionService.getLastNutritionRating();
      const latestRating = latestNutritionRating;
      dispatch(getNutritionRatingDataCall(userProfile, latestRating));
    } catch (error) {
      dispatch(getNutritionRatingDataError(error));
    }
  }
}

const setNutritionRatingRequest = (nutritionStarRating) => {
  return {
    type: SET_NUTRITION_RATING_REQUEST,
    payload: { nutritionStarRating }
  }
}
const setNutritionRatingSuccess = (userProfile) => {
  return {
    type: SET_NUTRITION_RATING_SUCCESS,
    payload: userProfile,
    ...analyicsForAction(SET_NUTRITION_RATING_SUCCESS)
  }
}

const setNutritionRatingFailed = (error) => {
  return {
    type: SET_NUTRITION_RATING_FAILED,
    payload: {
      error
    }
  }
}

export const setNutritionRating = (nutritionService, rating) => {
  return async (dispatch) => {
    dispatch(setNutritionRatingRequest(rating));
    try {
      const date = new Date();
      const updatedUserProfile = await nutritionService.captureNutritionRating(date, rating);
      dispatch(setNutritionRatingSuccess(updatedUserProfile));
    } catch (error) {
      firebaseErrorHandler(error);
      dispatch(setNutritionRatingFailed(error));
    }
  }
}

const setShoppingListSettingsRequest = () => ({
  type: SET_SHOPPING_LIST_SETTINGS_REQUEST,
})
const setShoppingListSettingsSuccess = () => ({
  type: SET_SHOPPING_LIST_SETTINGS_SUCCESS,
  ...analyicsForAction(SET_SHOPPING_LIST_SETTINGS_SUCCESS),
})
const setShoppingListSettingsFailed = () => ({
  type: SET_SHOPPING_LIST_SETTINGS_FAILED,
})

export const setShoppingListSettings = (nutritionService, mealPlanWithMeals, servingCount) => (
  async (dispatch) => {
    dispatch(setShoppingListSettingsRequest());
    try {
      const shoppingListExclusions = ShoppingListExclusion.ExtractShoppingListExclusionsFromMealPlan(mealPlanWithMeals);
      await nutritionService.setShoppingListSettings(shoppingListExclusions, servingCount);
      dispatch(getMealPlan(nutritionService));
      dispatch(setShoppingListSettingsSuccess());
    } catch (error) {
      dispatch(setShoppingListSettingsFailed(error));
    }
  }
);

const setChecklistExclusionsFailed = (err) => {
  return {
    type: SET_CHECKLIST_EXCLUSIONS_FAILED,
    payload: { err }
  }
}

export const setChecklistExclusions = (nutritionService, checklistExclusions) => {
  return async (dispatch) => {
    try {
      await nutritionService.setChecklistExclusions(checklistExclusions);
    } catch (error) {
      dispatch(setChecklistExclusionsFailed(error));
    }
  }
}

export const unCheckAllShoppingListItems = () => {
  return {
    type: UNCHECK_ALL_SHOPPING_LIST_ITEMS,
    ...analyicsForAction(UNCHECK_ALL_SHOPPING_LIST_ITEMS),
  }
}

export const toggleShoppingListItemCheckStatus = (itemIsChecked) => {
  return {
    type: TOGGLE_SHOPPING_LIST_ITEM_CHECK_STATUS,
    ...analyicsForAction(itemIsChecked ? 'nutrition_shoppinglist_checkitem' : 'nutrition_shoppinglist_uncheckitem'),
  }
}

export const orderMealsOpen = () => {
  return {
    type: ORDER_MEALS_OPEN,
    ...analyicsForAction(ORDER_MEALS_OPEN),
  }
}

export const setNutritionPreference = (nutritionPreference) => {
  return {
    type: SET_NUTRITION_PREFERENCE,
    payload: {
      ...nutritionPreference
    }
  }
}

export const setUnitPreference = () => {
  return { type: SET_UNIT_PREFERENCE };
};

const saveFoodPreferencesRequest = () => {
  return {
    type: SAVE_FOOD_PREFERENCES_REQUEST,
  }
}

const saveFoodPreferencesSuccess = () => {
  return {
    type: SAVE_FOOD_PREFERENCES_SUCCESS,
  }
}

const saveFoodPreferencesFailed = (error) => {
  return {
    type: SAVE_FOOD_PREFERENCES_FAILED,
    payload: {
      error
    }
  }
}

export const saveFoodPreferences = (nutritionService, foodPreferences) => {
  return async (dispatch) => {
    dispatch(saveFoodPreferencesRequest());
    try {
      const userProfile = await nutritionService.saveFoodPreferences(foodPreferences);
      dispatch(saveFoodPreferencesSuccess());
      dispatch(setNutritionPreference(userProfile.mealPreferences));
      dispatch(toggleFoodPreferencesModal(false));
      dispatch(toggleMealModal(false));
      dispatch(clearMealsForTimeOfDay());
    } catch (error) {
      dispatch(saveFoodPreferencesFailed(error));
    }
  }
}

export const savePreferences = (nutritionService, foodPreferences, useImperialUnit, dietGoal, gender) => {
  return async (dispatch) => {
    dispatch(saveFoodPreferencesRequest());
    try {
      const userProfile = await nutritionService.saveFoodPreferences(foodPreferences,
        useImperialUnit, dietGoal, gender);
      const mealPlan = await nutritionService.getMealPlan();
      const shoppingList = await nutritionService.getShoppingList();
      const serializedMealPlanData = NutritionSerializer.deserializeMealPlanWithMeals(mealPlan);
      dispatch(getMealPlanSuccess(serializedMealPlanData, shoppingList));
      dispatch(setNutritionPreference(userProfile.mealPreferences))
      dispatch(clearMealsForTimeOfDay())
    } catch (error) {
      dispatch(saveFoodPreferencesFailed(error));
    }
  }
}

const saveDietGoalRequest = () => {
  return {
    type: SAVE_DIET_GOAL_REQUEST,
  }
}

const saveDietGoalSuccess = () => {
  return {
    type: SAVE_DIET_GOAL_SUCCESS,
  }
}

const saveDietGoalFailed = (error) => {
  return {
    type: SAVE_DIET_GOAL_FAILED,
    payload: {
      error
    }
  }
}

export const saveDietGoal = (nutritionService, dietGoal) => {
  return async (dispatch) => {
    dispatch(saveDietGoalRequest());
    try {
      const userProfile = await nutritionService.saveDietGoal(dietGoal);
      dispatch(saveDietGoalSuccess());
      dispatch(setNutritionPreference(userProfile.mealPreferences));
      dispatch(toggleFoodPreferencesModal(false));
      dispatch(toggleMealModal(false));
      dispatch(clearMealsForTimeOfDay());
    } catch (error) {
      dispatch(saveDietGoalFailed(error));
    }
  }
}

const getMealPlanRequest = () => {
  return {
    type: GET_MEAL_PLAN_REQUEST,
  }
}

const getMealPlanSuccess = (mealPlan, shoppingList) => {
  return {
    type: GET_MEAL_PLAN_SUCCESS,
    payload: {
      mealPlan,
      shoppingList,
    }
  }
}

const getMealPlanFailed = (error) => {
  return {
    type: GET_MEAL_PLAN_FAILED,
    payload: {
      error
    }
  }
}

export const getMealPlan = (nutritionService) => {
  return async (dispatch) => {
    dispatch(getMealPlanRequest());
    try {
      const mealPlan = await nutritionService.getMealPlan();
      const shoppingList = await nutritionService.getShoppingList();
      const serializedMealPlanData = NutritionSerializer.deserializeMealPlanWithMeals(mealPlan);
      dispatch(getMealPlanSuccess(serializedMealPlanData, shoppingList));
    } catch (error) {
      Logger.notify(error, (report) => {
        report.errorClass = 'getMealPlan';
      });
      dispatch(getMealPlanFailed(error));
    }
  }
}

const getShoppingListRequest = () => {
  return {
    type: GET_SHOPPING_LIST_REQUEST,
  }
}

const getShoppingListSuccess = (shoppingList) => {
  return {
    type: GET_SHOPPING_LIST_SUCCESS,
    payload: {
      ...shoppingList,
    }
  }
}

const getShoppingListFailed = (error) => {
  return {
    type: GET_SHOPPING_LIST_FAILED,
    payload: {
      error
    }
  }
}

export const getShoppingList = (nutritionService) => {
  return async (dispatch) => {
    dispatch(getShoppingListRequest());
    try {
      const data = await nutritionService.getShoppingList();
      dispatch(getShoppingListSuccess(data));
    } catch (error) {
      dispatch(getShoppingListFailed(error));
    }
  }
}

export const getMealsForTimeOfDay = (nutritionService, mealOfDay, mealPlanId) => {
  return async (dispatch) => {
    dispatch(getMealsForTimeOfDayRequest(mealOfDay));
    try {
      const data = await nutritionService.getMealsForTimeOfDay(mealOfDay, mealPlanId);
      dispatch(getMealsForTimeOfDaySuccess(data, mealOfDay));
    } catch (error) {
      dispatch(getMealsForTimeOfDayFailed(error, mealOfDay));
    }
  }
}

export const getMealsForTimeOfDaySuccess = (meals, mealOfDay) => {
  return {
    type: GET_MEALS_FOR_TIME_OF_DAY_SUCCESS,
    payload: {
      meals: [...meals],
      mealOfDay: mealOfDay,
    }
  }
}

export const getMealsForTimeOfDayFailed = (error, mealOfDay) => {
  return {
    type: GET_MEALS_FOR_TIME_OF_DAY_FAILED,
    payload: {
      error: error,
      mealOfDay: mealOfDay,
    }
  }
}

export const getMealsForTimeOfDayRequest = (mealOfDay) => {
  return {
    type: GET_MEALS_FOR_TIME_OF_DAY_REQUEST,
    payload: {
      mealOfDay: mealOfDay,
    }
  }
}

export const setThumbnails = (thumbnails) => {
  return {
    type: SET_THUMBNAILS,
    payload: {
      thumbnails
    }
  }
}

export const setImage = (mealId, image) => {
  return {
    type: SET_IMAGE,
    payload: {
      mealId,
      image,
    }
  }
}

export const getImage = (nutritionService, mealId) => {
  return async (dispatch, getState) => {
    const { images } = getState().nutrition;
    if (!images[mealId]) {
      const imageBase64 = await nutritionService.getMealImage(mealId);
      dispatch(setImage(mealId, imageBase64))
    }
  }
}

const getThumbnailRequest = () => {
  return {
    type: GET_THUMBNAILS_REQUEST,
  }
}

export const getThumbnails = (nutritionService, mealPlanId) => {
  return async (dispatch) => {
    dispatch(getThumbnailRequest());
    const thumbnails = await nutritionService.getThumbnails(mealPlanId);
    dispatch(setThumbnails(thumbnails));
  }
}

export const updateTabIndex = (index) => {
  return {
    type: SET_TAB_INDEX,
    payload: index
  }
}

export const toggleMealSelectionWizardScreen = () => {
  return {
    type: TOGGLE_MEAL_SELECTION_WIZARD_SCREEN,
  };
};

export const setMaximumMealPrepTime = (maximumMealPrepTime) => {
  return  async (dispatch) => {
    await Storage.set('defaultmaximumMealPrepTimeState', JSON.stringify(maximumMealPrepTime));
    dispatch({
      type: MAXIMUM_MEAL_PREP_TIME_CHANGED,
      payload : {
        maximumMealPrepTime,
      }});
  };
};

export const getMaximumMealPrepTimeFromLocalStorage = () => {
  return async (dispatch) => {
    const maximumMealPrepTime = JSON.parse(await  Storage.get('defaultmaximumMealPrepTimeState', null));
    dispatch({
      type: MAXIMUM_MEAL_PREP_TIME_CHANGED,
      payload : {
        maximumMealPrepTime,
      }});
  };
};
